import { PRICING } from '../../data/mock';

export const isValidEmail = (val) =>
  typeof val === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val.trim());

export const isNonEmpty = (val) =>
  val !== null && val !== undefined && String(val).trim() !== '';

/**
 * Validate one step. Returns an `{ field: message }` map (empty when valid).
 * `tr` is the translation function from the parent component.
 */
export const validateStep = (step, formData, tr) => {
  const e = {};
  const reqText = tr('wizard.common.requiredText');
  const reqQ = tr('wizard.common.required');

  if (step === 1) {
    if (!isNonEmpty(formData.knowsPackage)) e.knowsPackage = reqQ;
    if (formData.knowsPackage === 'yes' && !isNonEmpty(formData.selectedPackage)) {
      e.selectedPackage = reqQ;
    }
  }

  if (step === 2) {
    if (!isNonEmpty(formData.whatBuilding)) e.whatBuilding = reqText;
    ['hasAddress', 'rfcNeeded', 'bankAccountNeeded', 'governanceNeeded',
     'landRestrictedZone'].forEach((k) => {
      if (!isNonEmpty(formData[k])) e[k] = reqQ;
    });
  }

  if (step === 3) {
    if (!isNonEmpty(formData.fullName)) e.fullName = reqText;
    if (!isNonEmpty(formData.email) || !isValidEmail(formData.email)) {
      e.email = tr('wizard.common.invalidEmail');
    }
    if (!isNonEmpty(formData.phoneCountryCode)) e.phoneCountryCode = tr('wizard.common.selectCountryCode');
    if (!isNonEmpty(formData.phone)) e.phone = tr('wizard.common.enterPhone');
    if (!isNonEmpty(formData.country)) e.country = reqText;
  }

  return e;
};

/**
 * Returns a recommendation-shaped object for any route key.
 * Used when the user pre-selected a package and we want to display that
 * instead of the computed recommendation.
 */
export const buildRecommendationForRoute = (route) => {
  if (route === 'customProject') {
    return { route, pricing: { type: 'custom' } };
  }
  const plan = PRICING[route];
  if (!plan) return { route, pricing: { type: 'one-time' } };
  return { route, planName: plan.name, pricing: plan };
};
